import { getStartAndEndDateForQuickOption } from "utils/dateUtils";
import { makeCancellableAPIRequest } from "./index";
import _ from "lodash";

const ScanAPI = {
    getAll(params = {}){
        return makeCancellableAPIRequest(
            "GET",
            "/api/scans",
            {
                params
            }
        )
    },
    getFilters(queryParams) {
        return makeCancellableAPIRequest(
            "GET",
            "api/scan-filters",
            {
                params: queryParams
            } 
        )
    },
    deleteScan(id){
        return makeCancellableAPIRequest(
            "DELETE",
            `/api/scans/${id}`
        )
    },
    getTrends(data) {
        const modifyData = modifyScanFilters(data);
        return makeCancellableAPIRequest(
            'POST',
            '/api/scans/trend',
            {
                data: modifyData
            }
        )
    },
    bulkScansDelete(data){
        return makeCancellableAPIRequest(
            "POST",
            `/api/scans/deleteList`,
            {
                data
            }
        )
    },
    scanCount(data){
        return makeCancellableAPIRequest(
            "POST",
            `/api/scans/count`,
            {
                data
            }
        )
    }
}

export default ScanAPI;

export const modifyScanFilters = (params) => {
    
        const filters = params.filters;

        if(params.filters?.id && filters.id[0]) {
            const id = filters.id[0];
            if(isNaN(id)) {
                if(id.match(/s-/gi)) {
                    filters.id[0] = id.split('-').pop();
                } else if(id === 's' || id === 'S') {
                    filters.id[0] = "";
                }
                if(filters.id[0] !== "" && isNaN(filters.id[0])){
                    filters.id[0] = -1;
                }
            }
        }
        if(params.filters?.createdAt && params.filters.createdAt.length === 1){
            filters.createdAt = getStartAndEndDateForQuickOption({
                label: filters.createdAt[0],
                utcString: true,
            });
        }

        if(params.filters?.scanDate && params.filters.scanDate.length === 1){
            filters.scanDate = getStartAndEndDateForQuickOption({
                label: filters.scanDate[0],
                utcString: true,
            });
        }

        if (params.filters?.tags) {
            params.filters.tags = _.map(params.filters.tags, tag => {
                const {key, value} = tag;
                let keyValue = key;
                if (value) {
                    keyValue = `${key}:${value}`;
                }
                return keyValue;
            });
        }

        return params;
}